
/**
 * 
 * 
 * Mine Clearance Utils
 * ===============================================================
 */
import store from '../store'
 /**
  * 初始化空阵列和数据对象
  * @export
  * @param {*} {row = 10, col = 10}
  * @returns
  */
 export function initMatrixSquare ({row = 10, col = 10}) {
   // init Matrix
  const matrix = Array.from({ length: row },  (r, ri) => {
    return Array.from({ length: col }, (c, ci) => {
      return {
        row: ri,
        col: ci,
        value: 0,
        round: null,
        isOpen: false,
        isMine: false,
        isFlag: false,
        extends: {
          isStone: false,
          isSymbol: false,
          isUFO: false,
        }
      }
    })
  })
  return {
    matrix,
    row,
    col
  }
 }

 /**
  * 配置矩阵中的地雷
  *
  * @export
  * @param {*} matrixSquare
  * @param {*} {mine = 50}
  * @returns
  */
 export function initMatrixMine (matrixSquare, {mine = 50, stone = 0 }, firstClickSquare, isOpenExtends) {
  if( !matrixSquare ) return

  const getRandomSquare = () => {
    const square = {
      row: Math.floor(Math.random() * matrixSquare.row ),
      col: Math.floor(Math.random() * matrixSquare.col )
    }
    return square.row === firstClickSquare.row && square.col === firstClickSquare.col ? getRandomSquare() : square
  }
  // generate mines
  while (mine > 0) {
    const { row, col } = getRandomSquare()
    const isMine = !!Math.round(Math.random())
    if (isMine) {
      const square = matrixSquare.matrix[row][col]
      if( !square['isMine'] ) {
        // 设置当前区块为地雷区块
        square['isMine'] = true
        store.dispatch('setBomb', square)
        mine--
      }
    }
  }

  // generate the extends params of the square with the exnteds params
  if ( isOpenExtends ) {
    // generate stones
    while ( stone > 0 ) {
      const { row, col } = getRandomSquare()
      const isStone = !!Math.round(Math.random())
      if( isStone ) {
        const square = matrixSquare.matrix[row][col]
        if( !square.extends.isStone && !square.isMine ){
          square.extends.isStone = true
          stone--
        }
      }
    }
  }

  return matrixSquare
 }

 /**
  * 计算矩阵中地雷周围的数字
  *
  * @export
  * @param {*} matrix
  */
 export function initMatrixMineNumber (matrix) {
    for( let i = 0; i < matrix.length; i++) {
      const row = matrix[i]
      for( let j = 0; j < row.length; j++) {
        let square = row[j]
        const roundSqure = calcRoundSquare(matrix, square)
        // 将环绕当前区块的所有区块的引用都赋值给当前区块，做关联
        if (!square.round) square.round = roundSqure
        // 如果当前区块不是地雷，则将周围区块中含有地雷的数量赋值给当前区块
        if(!square.isMine) {
          const roundSquareHasBombSize = Object.values(roundSqure).filter(v => v.isMine).length
          if( roundSquareHasBombSize ) {
            square.value = roundSquareHasBombSize
          }
        }
      }
    }
 }

 /**
  * 计算矩阵中某一个区块Square周围的区块并返回
  *
  * @param {*} matrix
  * @param {*} square
  * @returns
  */
 function calcRoundSquare (matrix, square) {
  const {row, col} = square
 
  const upRow = matrix[row - 1]
  const downRow = matrix[row + 1]

  return [
    upRow && matrix[row - 1][col - 1],
    upRow && matrix[row - 1][col],
    upRow && matrix[row - 1][col + 1],
    matrix[row][col - 1],
    matrix[row][col + 1],
    downRow && matrix[row + 1][col - 1],
    downRow && matrix[row + 1][col],
    downRow && matrix[row + 1][col + 1]
  ].filter( v => v)

 }

/**
 * 递归计算当前区块周围所有可翻开的区块并将其设置为已翻开状态
 *
 * @export
 * @param {*} matrix
 * @param {*} square
 */
export function calcRoundBlank(matrix, square) {
  const { round } = square
  for (let v of Object.values(round)) {
    // 需要递归翻开的必须是空区块 && 没有标记 && 不是地雷 && 没有翻开
    if (!v.isFlag && !v.isMine && !v.isOpen) {
      //
      v.isOpen = true

      // 如果是空区块则递归继续翻
      if( v.value === 0 ) calcRoundBlank(matrix, v)
    }
  }
 }

